import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { dropTask, task } from 'ember-concurrency';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

class BrandSignupCompanyInfoController extends Controller {
  @service('commands/company-commands') companyCommandService;
  @service('commands/stashed-data-commands') stashedDataCommandService;
  @service('commands/user-commands') userCommandService;
  @service('error-tracker') errorTracker;
  @service session;
  @service router;

  @tracked domainMatches = [];
  @tracked storedCompanyJoinRequest = null;

  @cached
  get companyDomainMatches() {
    return this.domainMatches.map((company) => ({
      key: company.name,
      value: company.id,
    }));
  }

  @action
  onBackClicked() {
    this.router.transitionTo(EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP__ABOUT_YOU);
  }

  @dropTask
  *initFunnel(user) {
    const companyJoinRequestUUID = sessionStorage.getItem('companyJoinRequestId')

    let companyJoinRequestPromise = Promise.resolve(null);
    let companyPromise = Promise.resolve(null);

    if (user.company) {
      companyPromise = this.companyCommandService.loadCompany(user.company.id, ['location']);
    } else if (companyJoinRequestUUID) {
      companyJoinRequestPromise = this.stashedDataCommandService.getByUUID(companyJoinRequestUUID);
    }

    [this.domainMatches, this.storedCompanyJoinRequest] = yield Promise.all([
      this.userCommandService.getCompanyDomainMatches(user),
      companyJoinRequestPromise,
      companyPromise,
    ]);
  }

  @task
  *storeOrUpdateCompanyJoinRequest(companyId, newCompanyName, department, jobTitle) {
    const userId = this.session.currentUser.id;

    const response = this.storedCompanyJoinRequest
      ? yield this.stashedDataCommandService.updateStashedCompanyJoinProposal(userId, companyId, newCompanyName, department, jobTitle)
      : yield this.stashedDataCommandService.createStashedCompanyJoinProposal(userId, companyId, newCompanyName, department, jobTitle);

    sessionStorage.setItem('companyJoinRequestId', response.uuid);

    yield this.session.loadCurrentUser();

    yield this.router
      .refresh(EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP)
      .catch(() => {});
  }

  @task
  *createOrUpdateCompany(companyName, companyImage, website, location) {
    const { company } = this.session.currentUser;

    if (company) {
      yield this.companyCommandService.updateCompany(
        company.id,
        companyName,
        {
          public_id: companyImage.cloudId,
          version: companyImage.cloudVersion,
        },
        website,
        location.id,
      );
    } else {
      yield this.companyCommandService.createNewCompany({
        name: companyName,
        description: '',
        opt_imageData: {
          public_id: companyImage.cloudId,
          version: companyImage.cloudVersion,
        },
        opt_locationId: location.id,
        opt_website: website,
      });
    }

    yield this.session.loadCurrentUser();

    yield this.router
      .refresh(EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP)
      .catch(() => {});
  }
}

export default BrandSignupCompanyInfoController;
